export const tourGuideSteps = [
  {
    selector: "#start-date-group",
    content: 
      "The beginning of the report range.",
  },
  {
    selector: "#end-date-group",
    content:
      "The end of the report range.",
  },
  {
    selector: "#message-status-filter-group",
    content:
      "Only messages with selected filters will be included in the report. If none are selected then message of all statuses will be included in the report.",
  },
  {
    selector: "#client-filter-group",
    content: 
      "Select a client to filter the list of environments and channels to choose from.",
  },
  {
    selector: "#client-environment-filter-group",
    content:
      "Select a client environment to filter the list of channels to choose from.",
  },
  {
    selector: "#channel-filter-group",
    content: 
      "Select which channels to include in the report.",
  },
  {
    selector: "#search-by-token-0",
    content: 
      "If the channel has messages with Search Tokens defined then you may select Search Tokens to filter messages.",
  },
  {
    selector: "#reset-filters-button",
    content:
      "Reset all filters."
  },
  {
    selector: "#schedule-report-button",
    content: 
      "Schedule the report to run on a certain date and time.",
  },
];

export const scheduleReportModalSteps = [
  {
    selector: "#scheduleReportNameFormGroup",
    content:
      "The name to give to this report."
  },
  {
    selector: "#scheduleReportExecutionTimeFormGroup",
    content: 
      "The date and time to run this report."
  },
  {
    selector: "#scheduleDistributeReportToOrganizationFormGroup",
    content: 
      "Whether this report should be shared with your organization. If unchecked, only you will see the report."
  },
  {
    selector: "#scheduleCancelButton",
    content: 
      "Cancel report creation."
  },
  {
    selector: "#scheduleConfirmButton",
    content: 
      "Schedule the report."
  },
];
